import { ApiResponse, OfferingDividend, OfferingId } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getOfferingDividends = async (offeringId: OfferingId) => {
  const response = await api.get<ApiResponse<OfferingDividend[]>>(`/offerings/${offeringId}/dividends`);

  return unwrapApiResponse(response.data);
};
